<!--
  切换角色 - 展示时机
  1. 游戏授权登录
  2. 切换角色 - 游戏跳转 & 游戏授权
-->
<template>
  <Dialog
    :visible.sync="visible"
    :title="$t('login.role')"
    :confirm-text="$t('game.confirm')"
    :cancel-text="roletype !== 'select' ? $t('game.orderCancel') : ''"
    :show-close="roletype !== 'select'"
    @close="close()"
    @confirm="updateCurrentRole"
    @cancel="close()"
    @touchmove.native.prevent
  >
    <div class="role_list" @touchmove.stop v-touchmove>
      <div
        class="role_item"
        :class="{ active: curRoleId === role.role_id }"
        v-for="role in roleList"
        :key="role.role_id"
        @click="curRoleId = role.role_id"
      >
        <UserInfo :showInfo="role" mode="choose_role" />
      </div>
    </div>
  </Dialog>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import UserInfo from '../userCard/userInfo.vue'

export default {
  components: {
    UserInfo,
  },
  data() {
    return {
      // select 登录选择角色, change 切换角色, in_game 游戏跳转登录
      roletype: '',
      curRole: undefined,
      visible: false,
      curRoleId: '',
    }
  },
  watch: {
    userInfo: {
      handler(newVal, oldVal) {
        // console.log('userInfo 发生了变化', newVal, oldVal);
        this.curRole = newVal
      },
      deep: true, // 如果 userInfo 是对象，监听内部属性变化
      immediate: true, // 如果需要在组件创建时立即执行
    },
    roleList: {
      handler(newVal, oldVal) {
        // console.log('userInfo 发生了变化', newVal, oldVal);
        if (this.roletype == 'select') {
          if (this.roleList[0]) {
            if (this.curRole && this.curRole.role_id) {
            } else {
              this.curRole = this.roleList[0]
            }
          }
        }
      },
      deep: true, // 如果 userInfo 是对象，监听内部属性变化
      immediate: true, // 如果需要在组件创建时立即执行
    },
  },
  computed: {
    ...mapState({
      gameId: (state) => state.app.gameId,
      loginType: (state) => state.user.loginType,
      userInfo: (state) => state.user.userInfo,
      roleList: (state) => state.user.roleList,
    }),
  },
  created() {
    // 切换角色
    this.$root.Bus.$on('toggleRole', this.showToggleRoleModal)
  },
  methods: {
    ...mapMutations(['SET_USERINFO']),
    updateCurrentRole() {
      const userinfo = this.roleList.find((item) => item.role_id === this.curRoleId)
      this.SET_USERINFO(userinfo)
      this.$root.Bus.$emit('sendmsg', {
        event: 'applogin',
        data: {
          ...userinfo,
          loginType: this.roletype === 'select' ? 'app' : this.loginType,
        },
        nologinis: this.roletype !== 'select',
      })
      this.taLog(userinfo)
      this.close()
    },
    showToggleRoleModal(data) {
      this.visible = true
      this.roletype = data.type
      if (data.type == 'change') {
        this.curRoleId = this.userInfo.role_id
      } else {
        if (this.roleList.filter((item) => item.role_id === data.roleId).length > 0) {
          this.curRoleId = data.roleId
        } else {
          this.curRoleId = this.roleList[0].role_id
        }
      }
    },
    close() {
      this.curRoleId = ''
      this.$emit('close')
    },

    taLog(userinfo) {
      var distinctId = this.$ta.getDistinctId()
      const commonData = {
        fake_id: userinfo.role_id,
        server_id: userinfo.extra_info && userinfo.extra_info.value,
        index_id: distinctId,
        to_type: this.$enum.LOGIN_TYPE[this.loginType],
      }

      if (this.roletype === 'select') {
        // 游戏授权登录
        commonData.operator_type = 1
      } else {
        // 切换角色 - 游戏跳转 & 游戏授权
        commonData.operator_type = 0
      }

      if (this.gameId === '20195') {
        commonData.is_web_unlock = userinfo.pay_threshold === 1
      }

      this.$ta.track('vip_mall_combine', {
        ...commonData,
        ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
      })
      this.$rum.report('login_operator_type', { ...commonData }, 1)
    },
  },
}
</script>

<style lang="less" scoped>
.role_list {
  max-height: 200px;
  padding: 1px 0;
  overflow-y: auto;
  .role_item {
    padding: 12px 10px;
    border: 1px solid #c1c7cd;
    border-radius: 12px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: stretch;
    min-height: 72px;
    & + .role_item {
      margin-top: 8px;
    }
    &:hover {
      border-color: #18a856;
    }
    &.active {
      border-color: #18a856;
      &::before {
        content: '';
        position: absolute;
        top: -1px;
        right: 0;
        width: 45.5px;
        height: 22px;
        .bg-image('icon_user_selected');
        z-index: 1;
      }
    }
  }
}
</style>
